import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { Check, Star, ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './ui/Button';
export function SalesProduct() {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const products = [{
    name: 'Vietnamese Bone Straight Hair',
    specs: ['8" - 32" Available', 'Thick Ends', 'Natural Black & Colored'],
    price: '$17 - $112',
    image: 'https://cdn.magicpatterns.com/uploads/3L4qqfWFdM5JWKwwkBoQFh/Bone-straight-hair-vietnamese.png',
    tag: 'Top Rated'
  }, {
    name: 'Vietnamese Curly/ Wavy Hair',
    specs: ['8" - 32" Available', 'Nice Texture', 'Natural Black & Colored'],
    price: '$18 - $113',
    image: 'https://cdn.magicpatterns.com/uploads/3RoHJJ4XEA5YHudSZN5Ufd/Curly-and-wavy-vietnamese-hair.png',
    tag: 'Factory Price'
  }, {
    name: 'Premium Closure/ Frontal & Wig',
    specs: ['HD Lace / Transparent', 'Pre-plucked', 'Small Knots'],
    price: '$16 - $165',
    image: 'https://cdn.magicpatterns.com/uploads/iB6UceFgA988RvQeKsLwGz/Closure-frontal-wig--vietnamese-hair.png',
    tag: 'High Demand'
  }, {
    name: 'Raw Vietnamese Hair Bundle',
    specs: ['For Braiding/Bleaching', 'Unprocessed', 'Full Cuticle Aligned'],
    price: '$30 - $180',
    image: 'https://cdn.magicpatterns.com/uploads/wEQZzBdfZnHLUrUgBbFtgW/Raw-vietnamese-hair-for-bleaching.png',
    tag: 'Popular'
  }];
  const scroll = (direction: 'left' | 'right') => {
    if (scrollContainerRef.current) {
      const scrollAmount = direction === 'left' ? -400 : 400;
      scrollContainerRef.current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  return <section className="pt-12 pb-20 bg-white" data-id="element-285">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-286">
        <div className="text-center mb-16" data-id="element-287">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-288">
            Featured Bestsellers
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-289">
            Our most requested products by wholesale partners. High profit
            margins and consistent quality guaranteed.
          </p>
        </div>

        <div className="relative" data-id="element-290">
          {/* Navigation Arrows - Desktop Only */}
          <button onClick={() => scroll('left')} className="hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 z-10 w-12 h-12 items-center justify-center rounded-full bg-white shadow-xl border border-gray-100 text-[#4B280B] hover:bg-[#4B280B] hover:text-white transition-all duration-300 hover:scale-110" aria-label="Scroll left" data-id="element-291">
            <ChevronLeft className="w-6 h-6" data-id="element-292" />
          </button>

          <button onClick={() => scroll('right')} className="hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 z-10 w-12 h-12 items-center justify-center rounded-full bg-white shadow-xl border border-gray-100 text-[#4B280B] hover:bg-[#4B280B] hover:text-white transition-all duration-300 hover:scale-110" aria-label="Scroll right" data-id="element-293">
            <ChevronRight className="w-6 h-6" data-id="element-294" />
          </button>

          {/* Scrollable Container */}
          <div ref={scrollContainerRef} className="flex gap-6 overflow-x-auto snap-x snap-mandatory scrollbar-hide pb-4" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-295">
            {products.map((product, index) => <motion.div key={product.name} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex-none w-[85%] sm:w-[45%] md:w-[calc(33.333%-16px)] lg:w-[calc(25%-18px)] snap-start" data-id="element-296">
                <div className="group rounded-2xl border border-gray-100 bg-white shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden h-full" data-id="element-297">
                  <div className="relative h-64 overflow-hidden" data-id="element-298">
                    <div className="absolute top-4 left-4 z-10 bg-[#7E3007] text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-299">
                      {product.tag}
                    </div>
                    <img src={product.image} alt={product.name} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" data-id="element-300" />
                  </div>

                  <div className="p-6" data-id="element-301">
                    <div className="flex items-center gap-1 mb-2" data-id="element-302">
                      {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-[#7E3007] text-[#7E3007]" data-id="element-303" />)}
                      <span className="text-xs text-gray-400 ml-1" data-id="element-304">(4.9)</span>
                    </div>

                    <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-305">
                      {product.name}
                    </h3>

                    <ul className="space-y-2 mb-6" data-id="element-306">
                      {product.specs.map(spec => <li key={spec} className="flex items-center text-sm text-gray-600" data-id="element-307">
                          <Check className="w-4 h-4 text-green-500 mr-2 flex-shrink-0" data-id="element-308" />
                          {spec}
                        </li>)}
                    </ul>

                    <div className="flex items-center justify-between mt-auto pt-4 border-t border-gray-100" data-id="element-309">
                      <div data-id="element-310">
                        <p className="text-xs text-gray-500" data-id="element-311">Wholesale Price</p>
                        <p className="text-lg font-bold text-[#4B280B]" data-id="element-312">
                          {product.price}
                        </p>
                      </div>
                      <Button size="sm" variant="outline" onClick={() => document.getElementById('contact')?.scrollIntoView({
                    behavior: 'smooth'
                  })} data-id="element-313">
                        Inquiry
                      </Button>
                    </div>
                  </div>
                </div>
              </motion.div>)}
          </div>

          {/* Scroll Indicator - Mobile */}
          <div className="md:hidden flex justify-center gap-2 mt-6" data-id="element-314">
            {products.map((_, index) => <div key={index} className="w-2 h-2 rounded-full bg-gray-300" data-id="element-315" />)}
          </div>
        </div>
      </div>

      <style jsx data-id="element-316">{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </section>;
}